<p class="resume-box__item">
  {{ translatedKey }}:
  <br *ngIf="breakLine" />
  <strong>{{ value }}</strong>
</p>
